import { ReactElement, useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RfUiAccordionCustom,
  RfUiButton,
  RfUiDatepicker,
  RfUiInput,
  RfUiModal,
  RfUiMultiselect,
  RfUiSelect,
  RfUiCheckbox,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectAlumnoPracticaParse2,
  makeSelectCursosPractica,
  makeSelectCursosPracticaParse2,
  makeSelectEstadosPracticas,
  makeSelectFechaMaximaPractica,
  makeSelectFechaMinimaPractica,
  makeSelectInstructoresCombinadoParse,
  makeSelectInstructoresPracticas,
  makeSelectInstructoresPracticasParse2,
  makeSelectSociedadesParse2,
} from 'store/practicas/selectors';
import {
  makeSelectFiltros,
  makeSelectNombreFiltro,
  makeSelectNombreInstructor,
  makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected,
  makeSelectPerfilesUsuarioIdUsuario,
  makeSelectPerfilesUsuarioNombreUsuario,
  makesSelectFiltrosParse,
} from 'store/usuarios/selectors';
import {
  getEstadosPracticaRequest,
  getFilterAlumnoPracticaRequest,
  getFilterCursosByInstructoresRequest,
  getFilterCursosByAlumnosRequest,
  getFilterInstructoresByAlumnosRequest,
  getFilterAlumnosByInstructoresRequest,
  getFilterCursoPracticaRequest,
  getInstructoresPracticasRequest,
  getSociedadesRequest,
  removePracticasFilter,
} from 'store/practicas/actions';
import { setStatePracticeSelected } from 'store/app/actions';
import {
  makeSelectDateMaxSelected,
  makeSelectDateMinSelected,
} from 'store/app/selectors';
import {
  deleteSavedPagination,
  getDefaultPracticeState,
  getDefaultStatus,
} from 'utils/practiceUtils';
import { arrayToAPI } from 'utils/listUtils';
import { language } from '../../utils/literals';
import { RouteTypes } from 'consts';
import { useHistory } from 'react-router';
import { getActualTime, getFirstDayOfTheMonthDate, getTodayFinishDate } from 'utils/dates-validators';
import { formatDateMax } from 'utils/dateTimeUtils';
import { EstadoPractica } from 'store/practicas/types';
import {
  isMobileOnly,
  isTablet,
  useMobileOrientation,
} from 'react-device-detect';
import { perfilesAlumno } from 'utils/profilesIndex';
import { FilterContainer } from 'containers/filterContainer';
import { listPracticasConstant } from 'pages/Home';
import { editarFiltroRequest, eliminarFiltroRequest, getFiltrosRequest, guardarFiltroRequest, removeFiltro, setFiltroFechaCreacion, setFiltroFechaModificacion, setFiltroId, setFiltroJson, setFiltroNombre, setFiltroNombrePagina } from 'store/usuarios/actions';



const selectors = createStructuredSelector({
  cursosPractica: makeSelectCursosPractica(),
  instructoresPractica: makeSelectInstructoresPracticas(),
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  nombreInstructor: makeSelectNombreInstructor(),
  dateMinSelected: makeSelectDateMinSelected(),
  dateMaxSelected: makeSelectDateMaxSelected(),
  idUsuario: makeSelectPerfilesUsuarioIdUsuario(),
  nombreUsuario: makeSelectPerfilesUsuarioNombreUsuario(),
  estadosPracticas: makeSelectEstadosPracticas(),
  fechaMinimaPractica: makeSelectFechaMinimaPractica(),
  fechaMaximaPractica: makeSelectFechaMaximaPractica(),
  // Remake
  estados: makeSelectEstadosPracticas(),
  cursos: makeSelectCursosPracticaParse2(),
  sociedades: makeSelectSociedadesParse2(),
  alumnos: makeSelectAlumnoPracticaParse2(),
  instructores: makeSelectInstructoresCombinadoParse(),
  filtro: makeSelectFiltros(),
  filtros: makesSelectFiltrosParse(),
  nombreFiltro: makeSelectNombreFiltro(),
  estadosFiltro: makeSelectEstadosPracticas(),
  cursosFiltro: makeSelectCursosPracticaParse2(),
  sociedadesFiltro: makeSelectSociedadesParse2(),
  alumnosFiltro: makeSelectAlumnoPracticaParse2(),
  instructoresFiltro: makeSelectInstructoresPracticasParse2(),
} as any);


const FilterListPractice = ({ handleSubmit, initValues }): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    profileActive,
    nombreInstructor,
    idUsuario,
    nombreUsuario,
    fechaMinimaPractica,
    fechaMaximaPractica,
    estadosPracticas,
    // Remake
    estados,
    cursos,
    sociedades,
    alumnos,
    instructores,
    filtro,
    filtros,
    nombreFiltro,
    cursosFiltro,
    sociedadesFiltro,
    instructoresFiltro,
    alumnosFiltro,
    estadosFiltro,
  } = useSelector<any, any>(selectors);


  const [savedFilterListPractice, setSavedFilterListPractice]: [any, any] =
    useState(initValues);

  const getSelectedFechaHasta = (): any => {
    if (savedFilterListPractice.savedValues === false) {
      return perfilesAlumno.includes(profileActive?.ID_PERFIL)
        ? fechaMaximaPractica?.FECHA_TIMESTAMP ?? getTodayFinishDate()
        : getTodayFinishDate();
    }
    return savedFilterListPractice.fechaFin;
  };

  const defaultEmptyFilter = {
    alumnos: '',
    ascDesc: '',
    cursos: '',
    elemFin: 10,
    elemInicio: 0,
    estados: profileActive?.ID_PERFIL.startsWith('1') ? 'PC,BO' : 'RE,PV',
    fechaFin: getSelectedFechaHasta(),
    fechaInicio: getFirstDayOfTheMonthDate(),
    instructores: '',
    orden: '',
    sociedades: '',
    savedValues: false,
    lastProfile: profileActive?.ID_PERFIL,
  };

  const [, setSelectedCursos]: [any, any] = useState('');


  const saveFilters = (filters) => {
    const filterToSave = {
      ...filters,
      lastProfile: profileActive?.ID_PERFIL,
    };
    setSavedFilterListPractice(filterToSave);
  };



  useEffect(() => {
    sessionStorage.setItem(
      `savedFilter-${window.location.pathname}`,
      JSON.stringify({ ...savedFilterListPractice, savedValues: true })
    );
  }, [savedFilterListPractice, window.location.pathname]);

  const getFechaDesdeListAlumn = (): number => {
    if (savedFilterListPractice.savedValues === false) {
      if (
        savedFilterListPractice.alumnos !== '' &&
        savedFilterListPractice.cursos !== ''
      ) {
        return fechaMinimaPractica?.FECHA_TIMESTAMP?.toString();
      } else {
        return getFirstDayOfTheMonthDate();
      }
    }
    return savedFilterListPractice.fechaInicio;
  };

  const [ultimoPerfilActivo, setUltimoPerfilActivo] = useState('');
  const [, setSelectedSociedades]: [any, any] = useState('');
  const [, setSelectedInstructores]: [any, any] = useState('');
  const [selectedFechaDesde, setSelectedFechaDesde]: [any, any] = useState(
    getFechaDesdeListAlumn()
  );
  const [selectedFechaHasta, setSelectedFechaHasta]: [any, any] = useState(
    getSelectedFechaHasta()
  );
  const [, setSelectedAlumnos]: [any, any] = useState('');

  const estadosPracticasParse = useMemo(() => {
    return JSON.stringify(
      estados.map((estadoPractica: EstadoPractica) => ({
        label: estadoPractica.NOMBRE_EST_PRACTICA,
        value: estadoPractica.ID_EST_PRACTICA,
      }))
    );
  }, [estados, savedFilterListPractice.estados]);

  const newInit = {
    ...savedFilterListPractice,
    fechaInicio: getFechaDesdeListAlumn(),
  };
  const [iniFilter, setInitFilter] = useState(newInit);

  useEffect(() => {
    setInitFilter(newInit);
    filter.current = { ...newInit };
  }, [savedFilterListPractice]);

  const filter: any = useRef(iniFilter);

  useEffect(() => {
    let courseArray = [{}];
    if (iniFilter.cursos !== '') {
      iniFilter.cursos.split(',').forEach((filterCurso) => {
        const newCourses = JSON.parse(cursos).filter((c) => {
          return c.value.toString() === filterCurso;
        });
        courseArray.push({
          label: newCourses[0].label.toString(),
          value: newCourses[0].value.toString(),
        });
      });
    }
    setSelectedCursos(JSON.stringify(courseArray));

    let alumnArray = [{}];
    if (iniFilter.alumnos !== '') {
      iniFilter.alumnos.split(',').forEach((filterAlumno) => {
        const newAlumns = JSON.parse(alumnos).filter((a) => {
          return a.value.toString() === filterAlumno;
        });
        alumnArray.push({
          label: newAlumns[0].label.toString(),
          value: newAlumns[0].value.toString(),
        });
      });
    }
    setSelectedAlumnos(JSON.stringify(alumnArray));

    let filtroArray = [{}];
    if (iniFilter?.filtros) {
      iniFilter.filtros.forEach((filtro: any) => {
        const newFiltros = JSON.parse(filtros).filter((f) => {
          return f.value.toString() === filtro;
        });
        filtroArray.push({
          label: newFiltros[0].label.toString(),
          value: newFiltros[0].value.toString(),
        });
      });
    }
    setSelectedFiltros(JSON.stringify(filtroArray));

    let societyArray = [{}];
    if (iniFilter.sociedades !== '') {
      iniFilter.sociedades.split(',').forEach((filterSociety) => {
        const newSociety = JSON.parse(sociedades).filter((s) => {
          return s.value.toString() === filterSociety;
        });
        societyArray.push({
          label: newSociety[0].label.toString(),
          value: newSociety[0].value.toString(),
        });
      });
    }

    setSelectedSociedades(JSON.stringify(societyArray));

    let instructorArray = [{}];
    if (iniFilter.instructores !== '') {
      iniFilter.instructores.split(',').forEach((filterInstructors) => {
        const newInstructors = JSON.parse(instructores).filter((i) => {
          return i.value.toString() === filterInstructors;
        });
        instructorArray.push({
          label: newInstructors[0].label.toString(),
          value: newInstructors[0].value.toString(),
        });
      });
    }
    setSelectedInstructores(JSON.stringify(instructorArray));
  }, []);

  const handleDateMinSelected = (e: any) => {
    setSelectedFechaDesde(e.detail);
    filter.current.fechaInicio = e.detail;
  };

  const parseDefaultStatesToString = (data: any) => {
    let res = '';
    data = JSON.parse(data);
    data.forEach((item: any) => {
      res = res === '' ? item.value : res + ',' + item.value;
    });
    return res;
  };

  let defaultPracticeState = useMemo(
    () => getDefaultPracticeState(profileActive, savedFilterListPractice),
    [profileActive, savedFilterListPractice]
  );

  useEffect(() => {
    dispatch(
      setStatePracticeSelected(parseDefaultStatesToString(defaultPracticeState))
    );
  }, [defaultPracticeState]);

  const handleDateMaxSelected = (e: any) => {
    if (filter.current) {
      setSelectedFechaHasta(formatDateMax(e.detail));
      filter.current.fechaFin = formatDateMax(e.detail);
    }
  };

  const handleStatePracticeSelected = (e: any) => {
    const estados = arrayToAPI(e.detail);
    filter.current = { ...filter.current, estados };
  };

  const handleSelectedCourse = (e: any) => {
    const cursos = arrayToAPI(e.detail);
    filter.current = { ...filter.current, cursos };

    const hasAlumnos = filter.current.alumnos !== '';

    if (!hasAlumnos) {
      dispatch(
        getFilterAlumnoPracticaRequest({
          cursos,
          sociedades: filter.current.sociedades,
        })
      );
      setSelectedAlumnos('[]');
    }
  };

  const handleSelecteSociety = (e: any) => {
    const sociedades = arrayToAPI(e.detail);
    filter.current = { ...filter.current, cursos: '', alumnos: '', sociedades };

    setSelectedCursos('[]');
    setSelectedAlumnos('[]');

    dispatch(getFilterCursoPracticaRequest({ sociedades }));
    dispatch(getFilterAlumnoPracticaRequest({ cursos: '', sociedades }));
  };

  const handleSelectedInstructor = (e: any) => {
    const instructores = arrayToAPI(e.detail);
    filter.current = { ...filter.current, instructores };

  };
  const [instructorVersion, setInstructorVersion] = useState(0);
  const [alumnoVersion, setAlumnoVersion] = useState(0);
  const [cursoVersion, setCursoVersion] = useState(0);

  const prevInstructorSelectionRef = useRef({
  alumnos: '',
  instructores: '',
  cursos: '',
  sociedades: '',
});

  const hasInstructorFilterChanged = () => {
  return (
    prevInstructorSelectionRef.current.alumnos !== (filter.current.alumnos || '') ||
    prevInstructorSelectionRef.current.instructores !== (filter.current.instructores || '') ||
    prevInstructorSelectionRef.current.cursos !== (filter.current.cursos || '') ||
    prevInstructorSelectionRef.current.sociedades !== (filter.current.sociedades || '')
  );
};

const saveInstructorFilterSnapshot = () => {
  prevInstructorSelectionRef.current = {
    alumnos: filter.current.alumnos || '',
    instructores: filter.current.instructores || '',
    cursos: filter.current.cursos || '',
    sociedades: filter.current.sociedades || '',
  };
};

const areAllSelected = (selectedCsv: string, optionsJson: string) => {
  try {
    const selected = selectedCsv ? selectedCsv.split(',').filter(Boolean) : [];
    const options = JSON.parse(optionsJson) || [];
    return options.length > 0 && selected.length === options.length;
  } catch {
    return false;
  }
};

const getSelectionStats = (selectedCsv: string, optionsJson: string) => {
  try {
    const selected = selectedCsv
      ? selectedCsv.split(',').filter(Boolean)
      : [];

    const options = JSON.parse(optionsJson) || [];

    return {
      selectedCount: selected.length,
      totalCount: Array.isArray(options) ? options.length : 0,
      allSelected:
        Array.isArray(options) &&
        options.length > 0 &&
        selected.length === options.length,
    };
  } catch {
    return {
      selectedCount: 0,
      totalCount: 0,
      allSelected: false,
    };
  }
};

const getSelectionLimitData = (selectedCsv: string, optionsJson: string) => {
  const allSelected = areAllSelected(selectedCsv, optionsJson);
  const stats = getSelectionStats(selectedCsv, optionsJson);

  return {
    allSelected,
    selectedCount: stats.selectedCount,
    overLimit: !allSelected && stats.selectedCount > 1000,
  };
};

const getCurrentFilterFlags = () => ({
  hasAlumnos: filter.current.alumnos !== '',
  hasCursos: filter.current.cursos !== '',
  hasInstructores: filter.current.instructores !== '',
});

const getValueForFilter = (allSelected: boolean, value: string) =>
  allSelected ? '' : value;

const applyInstructorBlurRequests = (
  instructoresParaFiltrar: string,
  alumnosParaFiltrar: string
) => {
  const { hasAlumnos, hasCursos, hasInstructores } = getCurrentFilterFlags();

  if (!hasInstructores && !hasCursos && !hasAlumnos) {
    dispatch(getFilterAlumnoPracticaRequest({ cursos: filter.current.cursos, sociedades: filter.current.sociedades }));
    dispatch(getFilterCursoPracticaRequest({ sociedades: filter.current.sociedades }));
    setSelectedAlumnos('[]');
    setSelectedCursos('[]');
  } else if (!hasInstructores && hasCursos && !hasAlumnos) {
    dispatch(getFilterAlumnoPracticaRequest({ cursos: filter.current.cursos, sociedades: filter.current.sociedades }));
    setSelectedAlumnos('[]');
  } else if (!hasInstructores && !hasCursos && hasAlumnos) {
    dispatch(getFilterCursosByAlumnosRequest({ alumnos: alumnosParaFiltrar }));
    setSelectedCursos('[]');
  } else if (hasInstructores && !hasAlumnos && !hasCursos) {
    dispatch(getFilterAlumnosByInstructoresRequest({ instructores: instructoresParaFiltrar }));
    dispatch(getFilterCursosByInstructoresRequest({ instructores: instructoresParaFiltrar }));
    setSelectedAlumnos('[]');
    setSelectedCursos('[]');
  } else if (hasInstructores && hasAlumnos && !hasCursos) {
    dispatch(getFilterCursosByInstructoresRequest({ instructores: instructoresParaFiltrar }));
    setSelectedCursos('[]');
  } else if (hasInstructores && !hasAlumnos && hasCursos) {
    dispatch(getFilterAlumnosByInstructoresRequest({ instructores: instructoresParaFiltrar }));
    setSelectedAlumnos('[]');
  }
};


  const handleBlurInstructores = (e: any) => {
    const instructorLimit = getSelectionLimitData(
      filter.current.instructores,
      instructores
    );
    const alumnoLimit = getSelectionLimitData(filter.current.alumnos, alumnos);
    const overLimit = instructorLimit.overLimit || alumnoLimit.overLimit;

    if (instructorLimit.overLimit) {
      openLimiteModalCerrado(instructorLimit.selectedCount, 'instructores');
    }

    if (alumnoLimit.overLimit) {
      openLimiteModalCerrado(alumnoLimit.selectedCount, 'alumnos');
    }

    if (!hasInstructorFilterChanged()) {
      saveInstructorFilterSnapshot();
      return;
    }

    if (!overLimit) {
      applyInstructorBlurRequests(
        getValueForFilter(instructorLimit.allSelected, filter.current.instructores),
        getValueForFilter(alumnoLimit.allSelected, filter.current.alumnos)
      );
    }

    saveInstructorFilterSnapshot();
};



const prevAlumnoSelectionRef = useRef({
  alumnos: '',
  instructores: '',
  cursos: '',
  sociedades: '',
});

const hasAlumnoFilterChanged = () => {
  return (
    prevAlumnoSelectionRef.current.alumnos !== (filter.current.alumnos || '') ||
    prevAlumnoSelectionRef.current.instructores !== (filter.current.instructores || '') ||
    prevAlumnoSelectionRef.current.cursos !== (filter.current.cursos || '') ||
    prevAlumnoSelectionRef.current.sociedades !== (filter.current.sociedades || '')
  );
};

const saveAlumnoFilterSnapshot = () => {
  prevAlumnoSelectionRef.current = {
    alumnos: filter.current.alumnos || '',
    instructores: filter.current.instructores || '',
    cursos: filter.current.cursos || '',
    sociedades: filter.current.sociedades || '',
  };
};


const applyStudentBlurRequests = (
  instructoresParaFiltrar: string,
  alumnosParaFiltrar: string
) => {
  const { hasAlumnos, hasCursos, hasInstructores } = getCurrentFilterFlags();

  if (!hasInstructores && !hasCursos && !hasAlumnos) {
    dispatch(getFilterInstructoresByAlumnosRequest({ alumnos: alumnosParaFiltrar }));
    dispatch(getFilterCursoPracticaRequest({ sociedades: filter.current.sociedades }));
    setSelectedInstructores('[]');
    setSelectedCursos('[]');
  } else if (!hasAlumnos && hasInstructores && !hasCursos) {
    dispatch(getFilterCursosByInstructoresRequest({ instructores: instructoresParaFiltrar }));
    setSelectedCursos('[]');
  } else if (!hasInstructores && hasCursos) {
    dispatch(getFilterInstructoresByAlumnosRequest({ alumnos: alumnosParaFiltrar }));
    setSelectedInstructores('[]');
  } else if (hasAlumnos && !hasInstructores && !hasCursos) {
    dispatch(getFilterInstructoresByAlumnosRequest({ alumnos: alumnosParaFiltrar }));
    dispatch(getFilterCursosByAlumnosRequest({ alumnos: alumnosParaFiltrar }));
    setSelectedInstructores('[]');
    setSelectedCursos('[]');
  } else if (hasAlumnos && hasInstructores && !hasCursos) {
    dispatch(getFilterCursosByAlumnosRequest({ alumnos: alumnosParaFiltrar }));
    setSelectedCursos('[]');
  }
};


  const handleBlurStudentSelected = (e: any) => {
    const instructorLimit = getSelectionLimitData(
      filter.current.instructores,
      instructores
    );
    const alumnoLimit = getSelectionLimitData(filter.current.alumnos, alumnos);

    if (instructorLimit.overLimit) {
      openLimiteModalCerrado(instructorLimit.selectedCount, 'instructores');
      return;
    }

    if (alumnoLimit.overLimit) {
      openLimiteModalCerrado(alumnoLimit.selectedCount, 'alumnos');
      return;
    }

    if (!hasAlumnoFilterChanged()) {
      saveAlumnoFilterSnapshot();
      return;
    }

    applyStudentBlurRequests(
      getValueForFilter(instructorLimit.allSelected, filter.current.instructores),
      getValueForFilter(alumnoLimit.allSelected, filter.current.alumnos)
    );

    saveAlumnoFilterSnapshot();
};






  const handleStudentSelected = (e: any) => {
    const alumnos = arrayToAPI(e.detail);
    filter.current = { ...filter.current, alumnos };

  };

const parseArrayMaybeJson = <T,>(source: any, fallback: T[] = []): T[] => {
  try {
    const parsed = typeof source === 'string' ? JSON.parse(source) : source;
    return Array.isArray(parsed) ? parsed : fallback;
  } catch (error) {
    return fallback;
  }
};

const parseEstadosMaybeJson = (source: any) => {
  try {
    const parsed = typeof source === 'string' ? JSON.parse(source) : source;
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

const splitCsv = (value: any): string[] => value ? value.toString().split(',') : [];

const updateFechaFinFiltro = (filtroValue: any) => {
  const fechaFiltroCargada = new Date(filtroValue.fechaFin);
  const hoy = new Date();
  const esMesActual =
    fechaFiltroCargada.getFullYear() === hoy.getFullYear() &&
    fechaFiltroCargada.getMonth() === hoy.getMonth();

  if (esMesActual) {
    filtroValue.fechaFin = getSelectedFechaHastaGF(filtroValue.fechaFin);
  }
};

const applySelectedFilter = (filtroValue: any) => {
  setSelectedFilter({
    alumnos: filtroValue.alumnos,
    sociedades: filtroValue.sociedades,
    instructores: filtroValue.instructores,
    cursos: filtroValue.cursos,
    estados: filtroValue.estados,
    fechaInicio: filtroValue.fechaInicio,
    fechaFin: filtroValue.fechaFin,
    savedValues: filtroValue.savedValues,
    elemFin: filtroValue.elemFin,
    elemInicio: filtroValue.elemInicio,
    lastProfile: filtroValue.lastProfile,
    ascDesc: filtroValue.ascDesc,
    orden: filtroValue.orden
  });
};

const buildUpdatedEstados = (filtroValue: any, parsedEstados: any[]) => {
  const estadoIds = splitCsv(filtroValue.estados);
  const uniqueEstados = new Set<string>();
  const updatedEstados = parsedEstados
    .filter((estado) => estadoIds.includes(estado.ID_EST_PRACTICA))
    .filter((estado) => {
      if (uniqueEstados.has(estado.ID_EST_PRACTICA)) {
        return false;
      }
      uniqueEstados.add(estado.ID_EST_PRACTICA);
      return true;
    })
    .map((estado) => ({
      label: estado.NOMBRE_EST_PRACTICA,
      value: estado.ID_EST_PRACTICA,
      active: 'true',
    }));

  estadoIds.forEach((estadoId) => {
    if (!updatedEstados.some((estado) => estado.value === estadoId)) {
      const estadoPractica = parsedEstados.find((estado) => estado.ID_EST_PRACTICA === estadoId);
      if (estadoPractica) {
        updatedEstados.push({
          label: estadoPractica.NOMBRE_EST_PRACTICA,
          value: estadoId,
          active: 'true',
        });
      }
    }
  });

  return updatedEstados;
};

const buildUpdatedOptionsByValue = (selectedCsv: string, parsedOptions: any[]) => {
  const selectedValues = splitCsv(selectedCsv);
  const uniqueValues = new Set<string>();
  const updatedOptions = parsedOptions
    .filter((option) => selectedValues.includes(option.value.toString()))
    .filter((option) => {
      if (uniqueValues.has(option.value)) {
        return false;
      }
      uniqueValues.add(option.value);
      return true;
    })
    .map((option) => ({
      ...option,
      active: 'true',
    }));

  selectedValues.forEach((selectedValue) => {
    if (!updatedOptions.some((option) => option.value === selectedValue)) {
      const optionFound = parsedOptions.find((option) => option.value === selectedValue);
      if (optionFound) {
        updatedOptions.push({
          label: `${selectedValue} - ${optionFound.label.split(' - ')[1]}`,
          value: selectedValue,
          active: 'true',
        });
      }
    }
  });

  return updatedOptions;
};

const buildUpdatedInstructores = (filtroValue: any, parsedInstructores: any[]) => {
  const instructorIds = splitCsv(filtroValue.instructores);
  const uniqueInstructores = new Set<string>();
  const updatedInstructores = parsedInstructores
    .filter((instructor) => {
      const instructorValue = instructor.value.toString();
      return instructorIds.includes(instructorValue) || instructorIds.includes(instructorValue.replace(/^L/, '')) || instructorIds.includes('L' + instructorValue);
    })
    .filter((instructor) => {
      const instructorValue = instructor.value.toString();
      if (uniqueInstructores.has(instructorValue)) {
        return false;
      }
      uniqueInstructores.add(instructorValue);
      return true;
    })
    .map((instructor) => ({
      ...instructor,
      active: 'true',
    }));

  instructorIds.forEach((instructorId) => {
    if (!updatedInstructores.some((instructor) => instructor.value === instructorId)) {
      const instructorPractica = parsedInstructores.find((instructor) => instructor.value === instructorId);
      if (instructorPractica) {
        updatedInstructores.push({
          label: `${instructorId} - ${instructorPractica.label.split(' - ')[1]}`,
          value: instructorId,
          active: 'true',
        });
      }
    }
  });

  return updatedInstructores;
};

const applyFilterDatesAndOptions = (filtroValue: any, combinedOptions: any[]) => {
  const minDateFromFilter = new Date(filtroValue.fechaInicio).getTime();
  const maxDateFromFilter = new Date(filtroValue.fechaFin).getTime();

  setOptionsFilter(JSON.stringify([
    ...combinedOptions,
    minDateFromFilter,
    maxDateFromFilter,
  ]));
  setMinDateFromFilter(JSON.stringify(minDateFromFilter));
  setMaxDateFromFilter(JSON.stringify(maxDateFromFilter));
};

const setFilterCurrentFromSelected = (filtroValue: any) => {
  filter.current = {
    ...selectedFilter,
    alumnos: filtroValue.alumnos,
    sociedades: filtroValue.sociedades,
    instructores: filtroValue.instructores,
    cursos: filtroValue.cursos,
    estados: filtroValue.estados,
    fechaInicio: filtroValue.fechaInicio,
    fechaFin: filtroValue.fechaFin,
    savedValues: filtroValue.savedValues,
    elemFin: filtroValue.elemFin,
    elemInicio: filtroValue.elemInicio,
    lastProfile: filtroValue.lastProfile,
    ascDesc: filtroValue.ascDesc,
    orden: filtroValue.orden
  };
};


  const handleSelectedFiltros = (e) => {
    setSelectedOptionFilter(true);
    setIsFilterActive(true);

    const filtroSeleccionado = e.detail;
    setSelectedFilterName(filtroSeleccionado.label);
    setSelectedFilterId(filtroSeleccionado.label.split(' - ')[0]);

    const filtroValue = JSON.parse(filtroSeleccionado.value);
    updateFechaFinFiltro(filtroValue);
    applySelectedFilter(filtroValue);

    const parsedCursos = parseArrayMaybeJson<{ label: string; value: string; active?: string }>(cursosFiltro);
    const parsedSociedades = parseArrayMaybeJson<{ label: string; value: string; active?: string }>(sociedadesFiltro);
    const parsedEstados = parseEstadosMaybeJson(estadosFiltro);
    const parsedInstructores = parseArrayMaybeJson<{ label: string; value: string; active?: string }>(instructoresFiltro);
    const parsedAlumnos = parseArrayMaybeJson<{ label: string; value: string; active?: string }>(alumnosFiltro);

    const updatedEstados = buildUpdatedEstados(filtroValue, parsedEstados);
    const updatedCursos = buildUpdatedOptionsByValue(filtroValue.cursos, parsedCursos);
    const updatedSociedades = buildUpdatedOptionsByValue(filtroValue.sociedades, parsedSociedades);
    const updatedInstructores = buildUpdatedInstructores(filtroValue, parsedInstructores);
    const updatedAlumnos = buildUpdatedOptionsByValue(filtroValue.alumnos, parsedAlumnos);

    setIsActiveCoursesChecked(!updatedCursos.some(curso => estadosExcluidos.includes(curso.state)));

    applyFilterDatesAndOptions(filtroValue, [
      ...updatedCursos,
      ...updatedSociedades,
      ...updatedInstructores,
      ...updatedAlumnos,
      ...updatedEstados,
    ]);
    setFilterCurrentFromSelected(filtroValue);
  };


  const cleanFilters = () => {
    deleteSavedPagination(window.location.pathname);
    setSelectedOptionFilter(false);
    setIsFilterActive(false);
    dispatch(removePracticasFilter());
    dispatch(removeFiltro());
    setSavedFilterListPractice(defaultEmptyFilter);
    handleSubmit(defaultEmptyFilter);
    setSelectedSociedades('[]');
    setSelectedInstructores('[]');
    setSelectedCursos('[]');
    setSelectedAlumnos('[]');
    setSelectedFiltros('[]');

    setSelectedFechaDesde(getFirstDayOfTheMonthDate());
    setSelectedFechaHasta(getSelectedFechaHasta());

    history.replace(RouteTypes.HOME);

    filter.current = { ...iniFilter };
    filter.current.fechaInicio = getFirstDayOfTheMonthDate();
    dispatch(getSociedadesRequest());
    dispatch(getEstadosPracticaRequest());
    dispatch(getInstructoresPracticasRequest());
    dispatch(getFilterCursoPracticaRequest({}));
    dispatch(getFilterAlumnoPracticaRequest({}));
    dispatch(getFiltrosRequest());

    setInstructorVersion((v) => v + 1);
    setAlumnoVersion((v) => v + 1);
    setCursoVersion((v) => v + 1);
  };

  const handlerSubmitFilters = () => {


      //Comprobar cantidad de opciones seleccionadas
      //instructores
      const stats = getSelectionStats(
        filter.current.instructores,
        instructores
      );

      const allInstructoresSelected = areAllSelected(
        filter.current.instructores,
        instructores
      );

      if(!allInstructoresSelected &&stats.selectedCount > 1000){
        openLimiteModalCerrado(stats.selectedCount, 'instructores');
        return;
      }else if(allInstructoresSelected){
        filter.current.instructores = '';
        setSelectedInstructores('[]');

      }

      //alumnnos
        const statsAlumnos = getSelectionStats(
        filter.current.alumnos,
        alumnos
      );

      const allAlumnosSelected = areAllSelected(
        filter.current.alumnos,
        alumnos
      );

      if(!allAlumnosSelected && statsAlumnos.selectedCount > 1000){
        openLimiteModalCerrado(statsAlumnos.selectedCount, 'alumnos');
        return;
      }else if(allAlumnosSelected){
        filter.current.alumnos = '';
        setSelectedAlumnos('[]');
      }

    filter.current = { ...filter.current, savedValues: true };
    deleteSavedPagination(window.location.pathname);
    saveFilters(filter.current);
    handleSubmit(filter.current);
  };
  useEffect(() => {
    if (
      profileActive &&
      ultimoPerfilActivo !== profileActive?.ID_PERFIL
    ) {
      setUltimoPerfilActivo(profileActive?.ID_PERFIL);
      cleanFilters();
    }
  }, [profileActive]);

  useEffect(() => {
    if (filter.current || !profileActive) {
      return;
    }
    setUltimoPerfilActivo(profileActive?.ID_PERFIL);
    const newIniFilter = getDefaultStatus(profileActive, iniFilter);

    setInitFilter(newIniFilter);
    filter.current = { ...newIniFilter };

    filter.current.fechaInicio = getFechaDesdeListAlumn();
    filter.current.fechaFin = getSelectedFechaHasta();
    setSelectedFechaDesde(getFechaDesdeListAlumn());
    setSelectedFechaHasta(getSelectedFechaHasta());
  }, [profileActive, fechaMaximaPractica]);

  useEffect(() => {
    setSelectedFechaHasta(getSelectedFechaHasta());
  }, [profileActive, fechaMaximaPractica]);

  const { isLandscape } = useMobileOrientation();

  //Filtro opciones
  const [selectedFiltros, setSelectedFiltros]: [any, any] = useState('');
  const [selectedFilterName, setSelectedFilterName] = useState('');
  const [selectedOptionFilter, setSelectedOptionFilter] = useState(false);
  const [modalCerradoFiltroGuardarType, setModalCerradoFiltroGuardarType] = useState('');
  const [modalCerradoFiltroEliminarType, setModalCerradoFiltroEliminarType] = useState('');
  const [modalCerradoFiltroEditarType, setModalCerradoFiltroEditarType] = useState('');
  const [selectedFilterId, setSelectedFilterId] = useState('');
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [minDateFromFilter, setMinDateFromFilter] = useState('');
  const [maxDateFromFilter, setMaxDateFromFilter] = useState('');
  const [optionsFilter, setOptionsFilter] = useState('');
  const [selectedFilter, setSelectedFilter] = useState({});
  const [modalCerradoLimmiteType, setModalLimiteCerradoType] = useState('');
  const [tituloModalLimiteSeleccionado, setTituloModalLimiteSeleccionado] = useState('');


  const filterNameAdd: boolean = useMemo(() => {
    return !!nombreFiltro;
  }, [nombreFiltro]);

  const openModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('empty');
  }

  const closeModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('');
  };

  const handleChangeFiltroNombre = (e: string) => {
    dispatch(setFiltroNombre(e));
  };

  //Cambio de fechas al guardar el filtro para que coja el mes completo
  const getSelectedFechaHastaGF = (fechaFin: number): number => {
  const fechaFiltro = new Date(fechaFin);
  const hoy = new Date();

  const esMesActual =
    fechaFiltro.getFullYear() === hoy.getFullYear() &&
    fechaFiltro.getMonth() === hoy.getMonth();

  if (esMesActual) {
    return hoy.getTime();
  }

  return new Date(
    fechaFiltro.getFullYear(),
    fechaFiltro.getMonth() + 1,
    0,
    23,
    59,
    59,
    999
  ).getTime();
};

const getSelectedFechaDesdeGF = (fechaInicio: number): number => {
  const fechaFiltro = new Date(fechaInicio);

  return new Date(
    fechaFiltro.getFullYear(),
    fechaFiltro.getMonth(),
    1,
    0,
    0,
    0,
    0
  ).getTime();
};



  const handleClickConfirmFilterButton = () => {

    filter.current.fechaFin = getSelectedFechaHastaGF(filter.current.fechaFin);
    filter.current.fechaInicio = getSelectedFechaDesdeGF(filter.current.fechaInicio);
    const filtroDatos = filter.current;



    const nombrePag = listPracticasConstant;
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    dispatch(guardarFiltroRequest(pagina, filtroJson));
    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.HOME);
  };
  //Editar filtro
  const openModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('confirm');
  };

  const closeModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('');
  };

 const confirmModalEditarFiltroCerrado = (filterName: string) => {
    handleClickEditarFiltroButton(filterName);
  };
  const handleClickEditarFiltroButton = (filterName: string) => {
    setModalCerradoFiltroEditarType('');

    const filtroDatos = filter.current;
    const filtroIdString = String(selectedFilterId);
    const nombrePag = listPracticasConstant;
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    const nombreFiltro = filterName.split(' - ')[1];
    const filtroSeleccionado = filtro.find(filtro => filtro.NOMBRE_FILTRO === nombreFiltro);
    const fechaCreacion = filtroSeleccionado.FECHA_CREACION;
    const fechaModificacion = getActualTime();

    dispatch(setFiltroNombre(nombreFiltro));
    dispatch(setFiltroId(filtroIdString));
    dispatch(setFiltroFechaCreacion(fechaCreacion));
    dispatch(setFiltroFechaModificacion(fechaModificacion));
    dispatch(editarFiltroRequest(filtroJson, pagina));
    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.HOME);
  }

  //Eliminar filtro
  const openModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('confirm');
  }

  const closeModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('');
  }

  const openLimiteModalCerrado = (seleccionados: number, titulo: string) => {
    setTituloModalLimiteSeleccionado(`Has seleccionado ${seleccionados} ${titulo}. Por favor, reduce tu selección hasta 1000 para aplicar el filtro.`);
    setModalLimiteCerradoType('alert');
  };
  const closeLimiteModalCerrado = () => {
    setModalLimiteCerradoType('');
  };

  const confirmModalEliminarFiltroCerrado = () => {
    handleClickEliminarFiltroButton();
  };

  const handleClickEliminarFiltroButton = () => {
    setModalCerradoFiltroEliminarType('');
    const filtroIdString = String(selectedFilterId);
    dispatch(setFiltroId(filtroIdString));
    dispatch(eliminarFiltroRequest(filtroIdString));
    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.HOME);
  }

  const [cursosFiltrados, setCursosFiltrados] = useState<any>();

   useEffect(() => {
    setInstructorVersion((v) => v + 1);
    }, [instructores]);

    useEffect(() => {
      setAlumnoVersion((v) => v + 1);
    }, [alumnos]);

    useEffect(() => {
      setCursoVersion((v) => v + 1);
    }, [cursosFiltrados]);

  const [isActiveCoursesChecked, setIsActiveCoursesChecked] = useState(true);

  const [estadosExcluidos] = useState(["CE", "FI"]);

  const handleCheckboxChange = (event) => {
    setIsActiveCoursesChecked(!isActiveCoursesChecked);
  };

  useEffect(() => {
    if (isActiveCoursesChecked) {
      const filtrados = JSON.parse(cursos).filter(curso => !estadosExcluidos.includes(curso.state));
      setCursosFiltrados(filtrados);
    } else {
      const filtrados = JSON.parse(cursos);
      setCursosFiltrados(filtrados);
    }
  }, [isActiveCoursesChecked, profileActive, cursos]);

  return (
    <>
      <RfUiAccordionCustom className="rf-accordion">
        <h2 className="rf-title rf-accordion__title">Filtrado</h2>
        <button
          className="rf-accordion__button rf-ui-accordion-custom__button"
          data-toggle="collapse"
          aria-expanded="false"
        >
          Mostrar filtros
        </button>

        <form
          id="courseForm"
          className="rf-accordion__content rf-ui-accordion-custom__panel collapse"
        >
          <div className="rf-box">
            <div>
              <div className={isTablet && isLandscape ? '' : 'rf-box__child'}>
                <div
                  className={
                    isTablet && isLandscape
                      ? 'rf-practice-list__input-container'
                      : 'rf-practice-list__input-container rf-practice-list__input-container--pr'
                  }
                >
                  <RfUiDatepicker
                    position={'left'}
                    moment-locale="es"
                    labelInput="Desde"
                    text-apply-button="Aplicar"
                    defaultMinDateFrom={
                      fechaMinimaPractica?.FECHA_TIMESTAMP
                        ? fechaMinimaPractica?.FECHA_TIMESTAMP?.toString()
                        : selectedFechaDesde
                    }
                    defaultMaxDateFrom={selectedFechaHasta}
                    defaultDateFrom={isFilterActive ? minDateFromFilter : selectedFechaDesde}
                    onDateSelected={(e: any) => {
                      handleDateMinSelected(e);
                    }}
                  />
                </div>
              </div>
              <div className={isTablet && isLandscape ? '' : 'rf-box__child'}>
                <div className="rf-practice-list__input-container">
                  <RfUiDatepicker
                    position={'left'}
                    moment-locale="es"
                    labelInput="Hasta"
                    text-apply-button="Aplicar"
                    defaultDateFrom={isFilterActive ? maxDateFromFilter : selectedFechaHasta}
                    defaultMinDateFrom={
                      selectedFechaDesde
                        ? selectedFechaDesde.toString()
                        : getTodayFinishDate().toString()
                    }
                    defaultMaxDateFrom={getTodayFinishDate().toString()}
                    onDateSelected={(e: any) => {
                      handleDateMaxSelected(e);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="rf-practice-list__input-container">
              {estadosPracticas.length > 0 && (
                <RfUiMultiselect
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  options={estadosPracticasParse}
                  text-label="Estado"
                  defaultChecksRemake={defaultPracticeState}
                  onOptionSelected={handleStatePracticeSelected}
                  placeholder="Seleccione estado"
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                />
              )}
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`curso-${cursoVersion}`}
                options={JSON.stringify(cursosFiltrados)}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                text-label="Curso"
                onOptionSelected={(e: any) => {
                  handleSelectedCourse(e);
                }}
                placeholder="Seleccione curso"
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>
            <div className="rf-practice-list__checkbox-container">
                <RfUiCheckbox
                  label="Cursos Activos"
                  checked={isActiveCoursesChecked}
                  onCheckEvent={handleCheckboxChange}
                /><small>Mostrar solo cursos activos</small>
            </div>
          </div>
          <div className="rf-box">
            {(profileActive?.ID_PERFIL === '511' || profileActive?.ID_PERFIL === '611') && (
              <div className="rf-practice-list__input-container">
                <RfUiMultiselect
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  text-label="Sociedad"
                  options={sociedades}
                  placeholder="Seleccione sociedad"
                  onOptionSelected={(e: any) => {
                    handleSelecteSociety(e);
                  }}
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                />
              </div>
            )}
            <div className="rf-practice-list__input-container">
              {profileActive?.ID_PERFIL === '211' ? (
                <RfUiInput
                  label="Instructor"
                  value={profileActive?.ID_USUARIO + ' - ' + nombreInstructor}
                  disabled={true}
                  error=""
                  placeholder="Seleccione instructor"
                />
              ) : (
                <RfUiMultiselect
                  key={`instructor-${instructorVersion}`}
                  options={instructores}
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  onOptionSelected={handleSelectedInstructor}
                  text-label="Instructor"
                  placeholder="Seleccione instructor"
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                  onBlur={handleBlurInstructores}
                />
              )}
            </div>
            <div className="rf-practice-list__input-container">
              {profileActive?.ID_PERFIL === '111' ||
                profileActive?.ID_PERFIL === '112' ||
                profileActive?.ID_PERFIL === '121' ||
                profileActive?.ID_PERFIL === '122' ||
                profileActive?.ID_PERFIL === '123' ? (
                <RfUiInput
                  label="Alumno"
                  value={idUsuario + ' - ' + nombreUsuario}
                  disabled={true}
                  error=""
                  placeholder="Seleccione alumno"
                />
              ) : (
                <RfUiMultiselect
                  key={`instructor-${alumnoVersion}`}
                  withoutOptionsText={language.validations.noOptions}
                  options={alumnos}
                  textError={language.validations.multiselectEmpty}
                  text-label="Alumno"
                  onOptionSelected={(e: any) => {
                    handleStudentSelected(e);
                  }}
                  placeholder="Seleccione alumno"
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                  onBlur={handleBlurStudentSelected}
                />
              )}
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiSelect
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                options={filtros}
                defaultChecked={selectedFiltros}
                label="Filtros"
                placeHolder="Seleccione Filtro"
                onOptionActive={handleSelectedFiltros}
                placeholder="Seleccione Filtro"
                optionFilter={selectedOptionFilter}
                onEdit={openModalEditarFiltroCerrado}
                onDelete={openModalEliminarFiltroCerrado}
              />
            </div>
            <div
              className={`rf-flex rf-justify-end rf-align-center rf-text-align-right
             ${isMobileOnly
                  ? 'rf-block--mobile rf-text-align-center--mobile'
                  : ''
                }`}
            >
              <RfUiButton
                text="Guardar filtros"
                text-help="Guardar filtros"
                aspect="secondary"
                onButtonClick={() => {
                  openModalGuardarFiltroCerrado();
                }}
              >
                {' '}
              </RfUiButton>
              <RfUiButton
                text="Limpiar filtros"
                text-help="Limpiar filtros"
                aspect="secondary"
                onButtonClick={() => {
                  cleanFilters();
                }}
              >
                {' '}
              </RfUiButton>
              <RfUiButton
                text="Filtrar"
                type="button"
                aspect="primary"
                className="rf-button rf-margin-left-30"
                onButtonClick={() => {
                  handlerSubmitFilters();
                }}
              >
                {' '}
              </RfUiButton>
            </div>
          </div>
        </form>
        <div>
          <RfUiModal
            title-Modal={'Nombre filtro'}
            id-modal="empty"
            modal-type={modalCerradoFiltroGuardarType}
            slot-content={true}
            onModalClose={(e: any) => {
              closeModalGuardarFiltroCerrado();
            }}
            onConfirm={() => {
              handleClickConfirmFilterButton();
            }}
          >
            <div slot="content">
              <FilterContainer
                title={language.filter.filterName}
                valueFilter={nombreFiltro}
                handleFilterChange={handleChangeFiltroNombre}
              />
            </div>
            <div slot="content">
              <RfUiButton
                disabled={!filterNameAdd}
                text={language.filter.sendConfirm}
                type="button"
                aspect="white"
                className="rf-button"
                onButtonClick={handleClickConfirmFilterButton}
              >
              </RfUiButton>
            </div>
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`Usted va a editar el filtro: ${selectedFilterName}`}
            id-modal="moralEdit"
            modal-type={modalCerradoFiltroEditarType}
            required-slot={false}
            onModalClose={() => {
              closeModalEditarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEditarFiltroCerrado(selectedFilterName);
            }}
          >
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`¿Esta seguro de que quiere eliminar el filtro? ${selectedFilterName}`}
            id-modal="modalDelete"
            modal-type={modalCerradoFiltroEliminarType}
            required-slot={true}
            onModalClose={(e: any) => {
              closeModalEliminarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEliminarFiltroCerrado();
            }}
          >
          </RfUiModal>
          <RfUiModal
                title-modal={tituloModalLimiteSeleccionado}
                id-modal="modal-validacion-cursos"
                modal-type={modalCerradoLimmiteType}
                onModalClose={(e: any) => {
                  closeLimiteModalCerrado();
                }}
                onConfirm={() => {
                  closeLimiteModalCerrado();
                }}
                modalConfirmText="Aceptar"
              ></RfUiModal>
        </div>
      </RfUiAccordionCustom>
    </>
  );
};

export default FilterListPractice;
